import { render, staticRenderFns } from "./candidatePublicity.vue?vue&type=template&id=9c68c414&scoped=true"
import script from "./candidatePublicity.vue?vue&type=script&lang=js"
export * from "./candidatePublicity.vue?vue&type=script&lang=js"
import style0 from "./candidatePublicity.vue?vue&type=style&index=0&id=9c68c414&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c68c414",
  null
  
)

export default component.exports